import * as React from 'react';
import { Spinner } from 'components/Spinner';
const PrintInvoiceRaw = React.lazy(() => import(/* webpackChunkName: "PrintInvoice" */ './PrintInvoice'));
export const PrintInvoice = () => (React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
    React.createElement(PrintInvoiceRaw, null)));
